import { History } from 'history'

function start(history: History) {
  const secret = 'bugbug'
  let iterator = 0
  document.addEventListener('keydown', function (event) {
    iterator = event.key === secret[iterator] ? iterator + 1 : 0
    if (iterator === secret.length) {
      iterator = 0
      history.push('/debug')
    }
  })
}

export default {
  start,
}
